module.exports = __webpack_public_path__ + "static/media/tipgoal-inactive.f2130f4a.svg";